import { createSlice } from '@reduxjs/toolkit';
import { refreshTenantPreference } from '../thunks/tenantPreferenceThunks';

const initialState = {
  dateFormat: 'DD/MM/YYYY',
  maxSizeOfDocuments: 3,
  loading: false,
  error: null,
};

const tenantPreferenceSlice = createSlice({
  name: 'tenantPreference',
  initialState,
  reducers: {
    setDateFormat: (state, action) => {
      state.dateFormat = action.payload || 'DD/MM/YYYY';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshTenantPreference.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(refreshTenantPreference.fulfilled, (state, action) => {
        state.loading = false;
        state.dateFormat = action.payload?.dateFormat || 'DD/MM/YYYY';
        state.maxSizeOfDocuments = action.payload?.maxSizeOfDocuments || 3;
      })
      .addCase(refreshTenantPreference.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch tenant preference';
        if (!state.dateFormat) {
          state.dateFormat = 'DD/MM/YYYY';
        }
      });
  },
});

export const { setDateFormat } = tenantPreferenceSlice.actions;
export default tenantPreferenceSlice.reducer;
